//bao migrate skip
import "./../../bindings/bao-upload";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import baoDialog from "../../factories/bao-dialog";
class ReminderTicketReferenceDocumentDialog {
    constructor(data: any, dialog: baoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
        this.UploadDocumentBinding = {
            Url: 'ReminderTicketReferenceDocument/UploadReferenceDocument?ticketReferenceDocumentId=' + this.TicketReferenceDocumentId(),
            Upload: 'Upload',
            Enabled: true
        };
    }
    Dialog: baoDialog;
    MetaData = ko.observable<string>();
    Class = ko.observable<string>();
    DocumentName = ko.observable<string>();
    TicketReferenceDocumentId = ko.observable<string>();
    IsDocumentNew = ko.observable(true);
    UploadDocumentBinding: Bindings.baoUpload;
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        if (!Bao.Utils.String.IsNullOrWhitespace(this.Class()) && !Bao.Utils.String.IsNullOrWhitespace(this.DocumentName())) {
                this.Dialog.IsLoading(true);
                this.Upload().then(() => {
                    this.Dialog.IsLoading(false);
                    def.resolve(true);
                });
        }
        else {
            def.resolve(false);
        }
        return def.promise();
    };
    Upload(): JQueryPromise<any> {
        //Dummy
        return null;
    }
    init() {
    }
    loaded() {
    }
}
export default ReminderTicketReferenceDocumentDialog;